import { useQuery } from "@tanstack/react-query"
import { useApi } from "../views/hooks/useApi"
import { FundamentalsMetricsResponse } from "../api/fundamentalsApi"

export const useFundamentalMetrics = (company_id?: number) => {
  const { scientApi } = useApi()

  const {
    data: { metrics, metrics_by_periodicity } = {
      metrics: [],
      metrics_by_periodicity: undefined,
    } as FundamentalsMetricsResponse,
    error,
    isLoading,
  } = useQuery({
    queryKey: ["fundamentalMetrics", company_id],
    queryFn: async () => {
      const res = await scientApi.fundamentals.getMetrics(company_id!)
      return res
    },
    enabled: Boolean(company_id),
    staleTime: 5 * 60 * 1000,
  })

  return { metrics, metrics_by_periodicity, error, isLoading }
}
